module.exports = "<button type=\"button\" class=\"{{btnClass}}\" (click)=\"openDialog()\">\n    <span *ngIf=\"type == 'image'\">\n        <i class=\"fa fa-image mr-4\"></i> {{btnTitle}}\n    </span>\n    <span *ngIf=\"type != 'image'\">\n        <i class=\"fa fa-file-o mr-4\"></i> {{btnTitle}}\n    </span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/upload/upload.component.html
// module id = ./src/app/modules/shared/upload/upload.component.html
// module chunks = main